import firebase from '../firebase/compat'
import { db } from '../firebase/config'
import { client } from '../hooks/Client'

// Firestore weigert een batch van meer dan 500 schrijfacties, en elk document
// kost er hier twee: markeren en registreren.
const DOCS_PER_BATCH = 250

/**
 * Markeert een reeks documenten uit één collectie als verwijderd (ADR-008), in
 * batches, en registreert ze als één geheel in `DeletedItems`.
 *
 * Nodig naast `softDeleteDoc` omdat die één document per twee schrijfacties
 * doet en geen band legt tussen documenten die samen één ding zijn — zoals de
 * tientallen antwoorden van één ingevuld formulier. Het eerste document wordt
 * de ouder, de rest krijgt `ParentID` van die ouder: `restoreDeletedItem` zet
 * bij het terugzetten van de ouder dan alles in één keer terug.
 *
 * Geef `parentId` mee als de ouder buiten de reeks staat — de widgets van een
 * rapportage hangen aan de rapportage zelf. Dan krijgen álle documenten die
 * `ParentID`.
 *
 * `DeletedAt` gebruikt serverTimestamp(), niet de `timestamp` uit
 * firebase/config (docs/pitfalls.md#state-stale-module-level-timestamp).
 * Een mislukte batch gooit door naar de aanroeper, zodat het scherm het kan
 * zeggen. Batches na de eerste zijn niet samen atomair met de eerste.
 * AI-CONTEXT: See docs/decisions.md (ADR-008) en docs/plans/prullenbak.md
 *
 * @param {object} params
 * @param {string} params.collection - Naam van de Firestore-collectie
 * @param {Array<string>} params.docids - Firestore-document-ids; het eerste wordt de ouder
 * @param {string} [params.authId] - Wie het verwijdert
 * @param {string} params.title - Wat de gebruiker in de prullenbak ziet
 * @param {string} [params.parentId] - Ouder buiten de reeks; alle documenten hangen eraan
 * @returns {Promise<number>} hoeveel documenten er gemarkeerd zijn
 */
const softDeleteDocs = async ({ collection, docids, authId, title, parentId: externalParentId }) => {
    if (!collection || !Array.isArray(docids) || docids.length === 0) return 0

    const parentId = externalParentId || docids[0]

    for (let i = 0; i < docids.length; i += DOCS_PER_BATCH) {
        const batch = db.batch()

        docids.slice(i, i + DOCS_PER_BATCH).forEach((docid) => {
            batch.update(db.collection(collection).doc(docid), {
                Deleted: true,
                DeletedAt: firebase.firestore.FieldValue.serverTimestamp(),
                DeletedBy: authId || '',
            })
            batch.set(db.collection('DeletedItems').doc(), {
                CompagnyID: client,
                Collection: collection,
                DocID: docid,
                Title: title || collection,
                DeletedAt: firebase.firestore.FieldValue.serverTimestamp(),
                DeletedBy: authId || '',
                ParentID: docid === parentId ? '' : parentId,
            })
        })

        await batch.commit()
    }

    return docids.length
}

export default softDeleteDocs
